import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { House, TrendingUp, Users, User, Sparkles } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useButtonsSection } from "./hooks/useButtonsSection";
import { useTeam } from "../../../contexts/TeamContext";
import styles from "./ButtonsSection.module.css";
import { useSubscriptionStatus } from "@/features/home/hooks/useSubscriptionStatus";
import { useAuth } from "@/contexts/AuthContext";
import { useFreeAccountCheck } from "@/features/home/hooks/useFreeAccountCheck";


const ButtonsSection = () => {
  const navigate = useNavigate();
  const shellRef = useRef<HTMLDivElement>(null);
  const { isActive } = useButtonsSection();
  const { isLead, teamId, organizationId, teamName, teams } = useTeam();
  const insightsPath = "/app/trends";
  const reportsPath = "/app/reports";
  const { userId } = useAuth();
  const { isFreeAccount, isLoadingAC } = useFreeAccountCheck({ userId });

  const {
    hasActiveSubscription,
    isUserSubscriptionValid,
    isLeadSubscriptionValid,
    isStillChecking,
    leadUid,
  } = useSubscriptionStatus({ userId });

  const tabClass = (active: boolean) =>
    `${styles.tab} ${active ? styles.tabActive : ""}`.trim();

  const iconProps = (active: boolean) => ({
    size: 22,
    strokeWidth: active ? 2.25 : 2,
    className: styles.tabIcon,
    "aria-hidden": true as const,
  });


  return (
    <div ref={shellRef} className={styles.tabBarShell}>
      <nav className={styles.tabBar} aria-label="Main tabs">
        <button
          type="button"
          className={tabClass(isActive("/app/home") || isActive("/"))}
          onClick={() => navigate("/app/home")}
        >
          <House {...iconProps(isActive("/app/home") || isActive("/"))} />
          <span className={styles.tabLabel}>Check-In</span>
        </button>

        {/*(organizationId === null || organizationId === undefined)*/ !isFreeAccount && !hasActiveSubscription && (
          <button
            type="button"
            className={tabClass(isActive("/app/premium") || isActive("/"))}
            onClick={() => navigate("/app/premium")}
          >
            <Sparkles
              {...iconProps(isActive("/app/premium") || isActive("/"))}
            />
            <span className={styles.tabLabel}>Upgrade</span>
          </button>
        )}

        {
            /*
            (teamId == null) &&
          !(teams.length == 0 && organizationId !== null) && (
            <button
              type="button"
              className={tabClass(isActive("/app/join-team") || isActive("/"))}
              onClick={() => navigate("/app/join-team")}
            >
              <Sparkles
                {...iconProps(isActive("/app/join-team") || isActive("/"))}
              />
              <span className={styles.tabLabel}>Join team</span>
            </button>
          )
      */}

        {organizationId != null && teamId != null &&
        <button
          type="button"
          className={tabClass(isActive(insightsPath))}
          onClick={() => navigate(insightsPath)}
        >
          <TrendingUp {...iconProps(isActive(insightsPath))} />
          <span className={styles.tabLabel}>Insights</span>
        </button>
        }

        { teamId != null &&
          <button
            type="button"
            className={tabClass(isActive(reportsPath))}
            onClick={() => navigate(reportsPath)}
          >
            <Users {...iconProps(isActive(reportsPath))} />
            <span className={styles.tabLabel}>Reports</span>
          </button>
        }

        <button
          type="button"
          className={tabClass(isActive("/app/settings"))}
          onClick={() => navigate("/app/settings")}
        >
          <User {...iconProps(isActive("/app/settings"))} />
          <span className={styles.tabLabel}>Account</span>
        </button>
      </nav>
    </div>
  );
};

export default ButtonsSection;
